/** Estado y puerto de autenticación del panel admin (testeable con fakes). */

export type AuthStatus =
  | 'loading'
  | 'checking-role'
  | 'role-error'
  | 'signed-out'
  | 'signed-in';

export interface AdminUser {
  uid: string;
  email: string | null;
  displayName: string | null;
}

export interface AuthState {
  status: AuthStatus;
  user: AdminUser | null;
  /**
   * Rol admin verificado. Mientras `status` sea `checking-role` permanece a
   * false, pero la UI no debe interpretarlo todavía como una denegación.
   */
  isAdmin: boolean;
}

export const INITIAL_AUTH_STATE: AuthState = {
  status: 'loading',
  user: null,
  isAdmin: false,
};

/**
 * Puerto de autenticación. El adaptador real (Firebase) vive en
 * `firebaseAuthSource.ts`; los tests inyectan un fake. Mantiene la lógica de UI
 * desacoplada de Firebase (mismo principio hexagonal que rider-core).
 */
export interface AuthSource {
  /** Observa cambios de sesión. Devuelve la función de baja. */
  subscribe(onChange: (state: AuthState) => void): () => void;
  signInWithGoogle(): Promise<void>;
  signOut(): Promise<void>;
  signInWithEmail?(email: string, password: string): Promise<void>;
  signInWithApple?(): Promise<void>;
  resetPassword?(email: string): Promise<void>;
  register?(name: string, email: string, password: string): Promise<void>;
  refresh?(): Promise<void>;
}
